module.exports = __webpack_public_path__ + "img/triangle.e8a12d9a.svg";